import script from "./DetalhesPurchaseOrderCompleto.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalhesPurchaseOrderCompleto.vue?vue&type=script&setup=true&lang=js"

import "./DetalhesPurchaseOrderCompleto.vue?vue&type=style&index=0&id=5edd8c68&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5edd8c68"]])

export default __exports__